import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import { TicketProvider } from './lib/ticket-state';
import { RealtimeBridge } from './components/RealtimeBridge';
import { PushProvider } from './lib/push';
import './styles.css';

createRoot(document.getElementById('root')!).render(<StrictMode><BrowserRouter><AuthProvider><PushProvider><TicketProvider><RealtimeBridge /><App /></TicketProvider></PushProvider></AuthProvider></BrowserRouter></StrictMode>);

const enableServiceWorker = (import.meta.env.PROD && import.meta.env.VITE_ENABLE_PWA !== 'false')
  || import.meta.env.VITE_ENABLE_PWA === 'true' || import.meta.env.VITE_ENABLE_PUSH === 'true';
if (enableServiceWorker && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => void navigator.serviceWorker.register('/sw.js', { updateViaCache: 'none' }));
} else if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then((items) => Promise.all(items.map((item) => item.unregister())));
}
